// Initialize Cloud Firestore through Firebase
import { initializeApp } from "firebase/app";
import { getFirestore, enableIndexedDbPersistence } from "firebase/firestore";
import { getToken, onMessage } from "firebase/messaging";
import { getMessaging, isSupported } from "firebase/messaging";
import { getDatabase } from "firebase/database";
import { getStorage } from "firebase/storage";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDgJh-_cvZL4f8WKVdgx8j5EwYP4cKrtvA",
  authDomain: "dcfever-ad70b.firebaseapp.com",
  databaseURL:
    "https://dcfever-ad70b-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "dcfever-ad70b",
  storageBucket: "dcfever-ad70b.appspot.com",
  messagingSenderId: "293799188096",
  appId: "1:293799188096:web:3fc22380dc56f3f1907865",
  measurementId: "G-JVC0YFMJR1",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

const db = getFirestore(app, {
  experimentalForceLongPolling: false,
});
// enableIndexedDbPersistence(db)
//   .then(() => {})
//   .catch((err) => {
//     if (err.code === "failed-precondition") {
//       // Multiple tabs open, persistence can only be enabled
//       // in one tab at a a time.
//       // ...
//     } else if (err.code === "unimplemented") {
//       // The current browser does not support all of the
//       // features required to enable persistence
//       // ...
//     }
//   });

const storage = getStorage(app);

const rtdb = getDatabase(app);

let messaging = null;
isSupported()
  .then((isMessagingSupported) => {
    if (isMessagingSupported) {
      messaging = getMessaging(app);
    }
  })
  .catch(/* error */);

const getMessagingToken = (setTokenFound) => {
  isSupported()
    .then((isMessagingSupported) => {
      if (isMessagingSupported) {
        const messaging = getMessaging(app);
        return getToken(messaging, {
          vapidKey:
            "BHIw2Juj5M2Y8l5atJxE-NDIpzdKWDVAVilnnN8DgBs8RrfqXLOewqwPteIli1L5oGh3NtQL21emL9XmS0_u5sw",
        })
          .then((currentToken) => {
            if (currentToken) {
              console.log("current token for client: ", currentToken);
              setTokenFound(true);
            } else {
              console.log(
                "No registration token available. Request permission to generate one."
              );
              setTokenFound(false);
            }
          })
          .catch((err) => {
            console.log("An error occurred while retrieving token. ", err);
          });
      }
    })
    .catch(/* error */);
};

const onMessageListener = () =>
  new Promise((resolve) => {
    const messaging = getMessaging(app);

    onMessage(messaging, (payload) => {
      console.log("Message received. ", payload);
      resolve(payload);
    });
  });

export {
  app,
  db,
  storage,
  rtdb,
  messaging,
  getMessagingToken,
  onMessageListener,
};
